import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instructors-style-two',
  templateUrl: './instructors-style-two.component.html',
  styleUrls: ['./instructors-style-two.component.scss']
})
export class InstructorsStyleTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
